import { otmsHttp, bmsHttp, bfsUserWebHttp } from '@/utils/http/index';

/**
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/31417
 * 转仓批量列表删除
 */
export function batchRemove(data) {
  return otmsHttp.post('/cms_plus/warehouse/transfer/batch/remove', data);
}

/**
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/31399
 * 转仓列表
 */
export function warehouseTransferPage(data, params) {
  return otmsHttp.post('/cms_plus/warehouse/transfer/page', data, { params });
}

/**
 *https://yapi.ops.yunlizhi.cn/project/571/interface/api/31411
 *新增转仓
 */
export function warehouseTransferCreate(data, params) {
  return otmsHttp.post('/cms_plus/warehouse/transfer/create', data, { params });
}

/**
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/6074
 * 查询所属客户下拉列表
 */
export function getCustomerList(data, params) {
  return otmsHttp.post('/crm_plus/customer/page', data, { params });
}

// 根据账号查询组织列表
// https://yapi.ops.yunlizhi.cn/project/295/interface/api/25310
export function projectList(data, params) {
  return bfsUserWebHttp.post('/crm-plus/project/page', data, { params });
}

/**
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/31405
 * 转仓链路更新
 */
export function warehouseTransferUpdate(data, params) {
  return otmsHttp.post('/cms_plus/warehouse/transfer/update', data, { params });
}

/**
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/31423
 * 绑定附加条件
 */
export function warehouseBindCondition(data, params) {
  return otmsHttp.post('/cms_plus/warehouse/transfer/bind/condition', data, { params });
}

/**
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/31435
 * 转仓详情
 */
export function warehouseTransferDetail(data, params) {
  return otmsHttp.post('/cms_plus/warehouse/transfer/detail', data, { params });
}

// 获取bms合同
export function getContractAllTypeList(data) {
  return bmsHttp.post('/bfs_pricing_rule/contract/all_type/list', data);
}

// 变更记录
// https://yapi.ops.yunlizhi.cn/project/571/interface/api/31453
export function warehouseHistoryList(data) {
  return otmsHttp.post('/cms_plus/warehouse/transfer/history/list', data);
}

/**
 *https://yapi.ops.yunlizhi.cn/project/571/interface/api/63217
 *批量修改Ext
 */
export function warehouseTransferUpdateExt(data, params) {
  return otmsHttp.post('/cms_plus/warehouse/transfer/updateExt/batch', data, { params });
}
